import { CohortClassStatus } from '../enums'

export const CLASSES_STATUS_COLOR: Record<CohortClassStatus, string> = {
  PENDIENTE: 'nucba.primary',
  EN_CURSO: '#ffa100',
  FINALIZADA: '#48BB78',
  POSTERGADA: '#d68035',
  ON_DEMAND: '#3182CE',
}
